// extracted by mini-css-extract-plugin
module.exports = {"component":"Filters_component__X7G9v","badges":"Filters_badges__25INN","tabs":"Filters_tabs__1ObFC"};